module.exports = __webpack_public_path__ + "img/gm.44e4c416.svg";